import React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import MainCard from './MainCard';
import { makeStyles } from 'tss-react/mui';

const ImageContentCard = React.forwardRef(
  ({ title, image, link, onClick, subTitle, disabled }, ref) => {
    const { classes } = useStyles();

    const Wrapper = link ? Link : 'div';

    return (
      <Wrapper
        to={link}
        onClick={ onClick }
        className={classes.linkWrapper}
        style={{ textDecoration: 'none' }}
      >
        <div className={disabled ? classes.contentcarddisabled : classes.contentcard}
        >
          <MainCard className={classes.mainCard} style={{
            transition: disabled ? 'none' : 'transform 0.3s ease-in-out',
            backgroundColor: disabled ? '#524545ff!important' : 'transparent',
          }}>
            <div className={classes.content} >
              {image && (
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    marginBottom: '16px',
                    padding:"10px"
                  }}
                >
                  <img
                    src={image}
                    alt={title}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                      transition: 'transform 0.3s ease-in-out',
                      transform: disabled ? 'none' : 'scale(1.1)',
                    }}
                  />
                </div>

              )}


              <Typography variant="h5" className={classes.title}>
                {title}
              </Typography>
              <Typography variant="h5" className={classes.subtitle}>
                {subTitle}
              </Typography>
            </div>
          </MainCard>
        </div>
      </Wrapper >
    );
  }
);

const useStyles = makeStyles({ name: 'ImageContentCard' })((theme) => ({
  contentcard: {
    width: '100%',
    height: '230px',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 8px 15px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease-in-out',
    background: 'transparent',
    position: 'relative',
    border: '2px solid transparent',
    backgroundClip: 'border-box',
    cursor: 'pointer',
    opacity: 1,
    backgroundColor: 'transparent',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 12px 30px rgba(0, 0, 0, 0.2)',
      border: '1px solid #FF6F61',
      background: 'linear-gradient(135deg, #FF6F61, #FF9A8B)',
    },
  },
  contentcarddisabled: {
    width: '100%',
    height: '230px',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 8px 15px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease-in-out',
    background: 'transparent',
    position: 'relative',
    border: '2px solid transparent',
    backgroundClip: 'border-box',
    cursor: 'pointer',
    opacity: 0.5,
    backgroundColor: '#d3d3d3',

  },
  mainCard: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '20px',
    cursor: 'pointer',
    transition: 'transform 0.3s ease-in-out',
    height: '200px',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '200px',
    width: '100%',
    cursor: 'pointer',
  },
  image: {
    width: '80px',
    height: '80px',
    objectFit: 'cover', // Ensures image fills the box and crops overflow
    borderRadius: '10px',
    marginBottom: theme.spacing(2),
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  }
  ,
  title: {
    fontWeight: 700,
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
    transition: 'color 0.3s ease-in-out',
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  subtitle: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    marginTop: theme.spacing(0.5),
  },
  linkWrapper: {
    display: 'block',
    textDecoration: 'none',
  },
  imageContainer: {
    width: '100%',
    height: '60px',
    backgroundSize: 'cover', // Ensures full cover with cropping
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '10px',
    marginBottom: theme.spacing(2),
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  }

}));

export default ImageContentCard;
